// extracted by mini-css-extract-plugin
module.exports = {"icon":"Accordion_icon__3scBi","toggle":"Accordion_toggle__1PonV","header":"Accordion_header__2eHiu","accordion":"Accordion_accordion__2c06M"};